import { MessageCircleMore, Video } from "lucide-react";
import { motion } from "framer-motion";

function Floating() {
  return (
    <>
      {/* WhatsApp */}
      <motion.div
        className="fixed bottom-24 right-5 z-50"
        initial={{ x: -5, opacity: 0 }}
        whileInView={{
          opacity: 1,
          transition: {
            delay: 0.4,
          },
        }}
        whileHover={{ x: 0, scale: 1.05 }}
      >
        <a
          href="https://wa.me/593999565400"
          target="_blank"
          rel="noreferrer"
          className="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 shadow-xl hover:bg-green-600 transition-all"
        >
          <MessageCircleMore className="text-white w-7 h-7" />
        </a>
      </motion.div>

      {/* Zoom */}
      <motion.div
        className="fixed bottom-5 right-5 z-50"
        initial={{ opacity: 0, x: -5 }}
        whileInView={{
          opacity: 1,
          transition: {
            delay: 0.1,
          },
        }}
        whileHover={{ x: 0, scale: 1.05 }}
      >
        <a
          href="https://utpl.edu.ec/zoom"
          target="_blank"
          rel="noreferrer"
          className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-500 shadow-xl hover:bg-blue-600 transition-all"
        >
          <Video className="text-white w-7 h-7" />
        </a>
      </motion.div>
    </>
  );
}

export default Floating;